import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HydrocelePage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Hydrocele</h1>
        <section className="mb-8">
          <p>A hydrocele is a fluid-filled sac around the testicle that can cause swelling and discomfort. Our natural therapies focus on reducing fluid accumulation, improving circulation, and promoting healing without invasive procedures.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Injury or trauma</li>
            <li>Infection</li>
            <li>Inflammation</li>
            <li>Blockage in lymphatic system</li>
            <li>Congenital factors</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Swelling in scrotum</li>
            <li>Heaviness or discomfort</li>
            <li>Pain or tenderness</li>
            <li>Difficulty with movement</li>
            <li>Visible enlargement</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use anti-inflammatory herbs, lymphatic drainage techniques, and lifestyle modifications to naturally treat hydrocele. Our approach focuses on reducing fluid accumulation, improving circulation, and promoting healing through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Non-surgical treatment</li>
            <li>Reduces swelling naturally</li>
            <li>Improves circulation</li>
            <li>Prevents recurrence</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Wear supportive underwear</li>
            <li>Avoid heavy lifting</li>
            <li>Maintain good hygiene</li>
            <li>Regular gentle exercise</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment cure hydrocele without surgery?</strong>
            <p>A: Yes, our natural approach can effectively treat many cases of hydrocele without surgical intervention.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment painful?</strong>
            <p>A: Our treatments are gentle and focus on reducing discomfort while promoting healing.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How long does treatment take?</strong>
            <p>A: Treatment duration varies, but many patients see improvement within a few months.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from hydrocele—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default HydrocelePage; 